module.exports = __webpack_public_path__ + "static/media/btn.28a0f6a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/btn.png
// module id = 1670
// module chunks = 0